export enum SidebarOptionType {
  Recipient = 'recipient',
  Chat = 'chat',
  Invite = 'invite',
  Download = 'download',
  Call = 'call',
  Reject = 'reject',
  Print = 'print',
  Help = 'help',
}
